export const miniBannersFetchTimer = 60000; //60 * 1000